import { createSlice } from "@reduxjs/toolkit";
import { getAllData } from "../../utils";

const petFormDataColor = await getAllData("color");
const petFormDataRaza = await getAllData("raza");
const petFormDataTipo = await getAllData("tipoMascota");
const petFormDataEstado = await getAllData("estado");
const petFormDataSexo = await getAllData("sexo");
const petFormDataSize = await getAllData("tamano");

export const compartirMascotaSlice = createSlice({
  name: "compartirMascotaFormData",
  initialState: {
    color: petFormDataColor,
    raza: petFormDataRaza,
    tipo: petFormDataTipo,
    estado: petFormDataEstado,
    tamano: petFormDataSize,
    sexo: petFormDataSexo
  },

  //Van las functions donde le decis que hara para actualizar, eliminar etc el estado.
  reducers: {},
});

// Action creators are generated for each case reducer function
export const { getMascotaFormData } = compartirMascotaSlice.actions;

export default compartirMascotaSlice.reducer;
